import { render } from "./FormPropsCmp.vue?vue&type=template&id=7e5cc48a"
import script from "./FormPropsCmp.vue?vue&type=script&lang=js"
export * from "./FormPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__